package com.upcominds.expedite.data

import kotlinx.browser.window

actual object AppConfig {
    actual val baseUrl: String
        get() {
            val env = window.asDynamic().__env
            return if (env != undefined && env.API_BASE_URL != undefined) {
                env.API_BASE_URL as String
            } else {
                "http://localhost:8080" // Fallback
            }
        }

    actual val keycloakUrl: String
        get() {
            val env = window.asDynamic().__env
            return if (env != undefined && env.KEYCLOAK_ISSUER_URI != undefined) {
                 env.KEYCLOAK_ISSUER_URI as String
            } else {
                "https://core.expedite.iti.onl/auth/realms/expedite" // Fallback
            }
        }
}
